import {
  isSameDay,
  isSameMonth,
  isSameWeek,
  subDays,
  subMonths,
  subWeeks,
} from "date-fns";
import { dateFormatter } from "utils/helpers";
import { IEffortActual } from "../../Ticket/types";

export enum ActivityDateGroup {
  Today = "Today",
  Yesterday = "Yesterday",
  ThisWeek = "This week",
  LastWeek = "Last week",
  ThisMonth = "This month",
  LastMonth = "Last month",
  Older = "Older",
}

export function formatRelativeTime(timestamp: string): string {
  return dateFormatter(timestamp, "auditLog");
}

export function getActivityDateGroup(timestamp: string): string {
  const date = new Date(timestamp);
  const now = new Date();

  if (isSameDay(date, now)) return ActivityDateGroup.Today;
  if (isSameDay(date, subDays(now, 1))) return ActivityDateGroup.Yesterday;

  if (isSameWeek(date, now)) return ActivityDateGroup.ThisWeek;
  if (isSameWeek(date, subWeeks(now, 1))) return ActivityDateGroup.LastWeek;

  if (isSameMonth(date, now)) return ActivityDateGroup.ThisMonth;
  if (isSameMonth(date, subMonths(now, 1))) return ActivityDateGroup.LastMonth;

  return ActivityDateGroup.Older;
}

export const toTitleCase = (str: string) => {
  if (!str) return "";
  return str.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(),
  );
};
